import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';
const Header21 = () => {
  return <header className="bg-white" data-id="element-1278">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-1279"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-1280">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-1281">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-1282">
            MEDPRESS GAZETTE
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-1283">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-1284">
          <div className="text-left" data-id="element-1285">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-1286">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-1287">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header - CUSTOM FOR ADV-2-1 */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-1288">
        <div className="max-w-4xl mx-auto" data-id="element-1289">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-1290">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-1291">
            Nurse Practitioner Investigates: What Actually Works For Hair
            Regrowth (And What's A Waste Of Money and Time)
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-1292">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-1293">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss" className="w-full h-full object-cover" data-id="element-1294" />
            </div>
            <div className="flex-1" data-id="element-1295">
              <div className="flex items-center" data-id="element-1296">
                <div className="font-medium text-gray-900 text-lg" data-id="element-1297">
                  By Margaret Weiss, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-1298">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-1299" />
                  <span className="text-xs ml-1 font-medium" data-id="element-1300">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-1301">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-1302">
                <div className="flex items-center mr-4" data-id="element-1303">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-1304" />
                  <span data-id="element-1305">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-1306">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-1307" />
                  <span data-id="element-1308">31,492 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-1309">
            I've spent 28 years evaluating medical devices - from grounding
            sheets to heat therapy pads. Hair loss was never my specialty...
            until my brother admitted he was losing the silent battle with his
            thinning hair. What started as helping family turned into a 12-month
            investigation that could save you thousands – and might actually
            save your hair.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-1310">
            <div className="mb-1 flex items-center" data-id="element-1311">
              <span className="font-medium mr-2" data-id="element-1312">Published by:</span>
              MedPress Gazette Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-1313">
              <span className="font-medium mr-2" data-id="element-1314">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-1315">
        <div className="max-w-4xl mx-auto" data-id="element-1316">
          <div className="sm:flex items-center" data-id="element-1317">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-1318">
              <img src="https://cdn.magicpatterns.com/uploads/pgHF1VNF6Whvw8QDg83TjW/31.png" alt="Margaret Weiss, RN, MSN" className="w-full rounded-lg shadow-md" data-id="element-1319" />
            </div>
            <div className="sm:w-2/3" data-id="element-1320">
              <p className="text-sm text-gray-700 mb-2" data-id="element-1321">
                <span className="font-bold" data-id="element-1322">Margaret Weiss, RN, MSN</span> has 
                spent nearly three decades in clinical practice specializing 
                in integrative medicine. As the former Head of Integrative 
                Medicine at Cedar Sinai Medical Center, she has conducted 
                independent investigations of hundreds of wellness products 
                and medical devices.
              </p>
              <p className="text-sm text-gray-700" data-id="element-1323">
                Her approach is direct: test products with real patients, 
                measure outcomes, and distinguish effective treatments 
                from effective marketing hype.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header21;